import { Component, Renderer2 } from '@angular/core';
import { MessageType } from '../shared/model/message-type';
import { SocketService } from '../shared/services/socket.service';
import { CookieService } from 'ngx-cookie-service';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../shared/model/user';
import { Message } from '../shared/model/message';
import { GameStatus } from '../shared/model/game-status';
import { GameHostComponent } from '../game-host/game-host.component';
import { SpinnerService } from '../shared/services/spinner.service';
import { WindowsService } from '../shared/services/windows.service';

@Component({
  selector: 'pbg-page-trivia-host',
  templateUrl: './page-trivia-host.component.html',
  styleUrls: ['./page-trivia-host.component.scss']
})
export class PageTriviaHostComponent extends GameHostComponent {
  ioConnection: any;
  user: User = {};
  connectedUsers: User[] = [];
  gamePrefix = 'T';
  gameId = '';
  gameOverMessage = '';
  currentQuestion: any;
  winner: string;

  // Dynamic Styling
  avatarWidth = '100%';

  constructor(
    socketService: SocketService,
    cookieService: CookieService,
    router: Router,
    resolver: ActivatedRoute,
    renderer: Renderer2,
    spinnerService: SpinnerService,
    windowService: WindowsService
  ) {
    super(
      socketService,
      cookieService,
      router,
      resolver,
      renderer,
      spinnerService,
      windowService
    );
  }

  hostMessageHandler(message: Message) {
    if (message.action === MessageType.Host) {
      this.connectedUsers = (<any>Object).values(message.content.users);
      this.avatarWidth = `calc(${Math.floor(100 / this.connectedUsers.length)}% - 20px)`;
      if (message.content.status === GameStatus.Waiting) {
        this.gameId = message.content.id;
        this.cookieService.set('gameId', this.gameId, 1, '/');
      } else if (message.content.status === GameStatus.Complete) {
        this.winner = message.content.winner.name;
        this.gameOverMessage = `${this.winner} has won the race!`;
      }
    }
  }

  responseHandler(message) {
    if (message.action === MessageType.Question) {
      this.connectedUsers = (<any>Object).values(message.content.users);
      this.avatarWidth = `calc(${Math.floor(100 / this.connectedUsers.length)}% - 20px)`;
      this.currentQuestion = message.content.currentQuestion;
    }
  }

  getScoreHeight(currentScore): string {
    const rawScore = currentScore > 100 ? 100 : currentScore;

    return Math.floor(rawScore * 0.45) + 'vh';
  }
}
